import { render, staticRenderFns } from "./FacilityFilesList.vue?vue&type=template&id=f585c8dc&scoped=true&"
import script from "./FacilityFilesList.vue?vue&type=script&lang=js&"
export * from "./FacilityFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f585c8dc",
  null
  
)

export default component.exports